import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import SuperAdminPanel from '../../components/sections/SuperAdminPanel';

export default function AdminPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-indigo-50">
      <Navbar activeSection="admin" />
      <SuperAdminPanel />
      <Footer />
    </div>
  );
}
